import React, { useEffect, useState } from "react";
import "./style.scss";
import axios from "axios";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import { getToken } from "../../auth/authConfig";

const CBUserReg = () => {
  // State to manage form inputs
  const [isLoading, setIsloading] = useState(false);
  const [issuccess, setsuccess] = useState(false);
  const [iserror, seterror] = useState(false);
  const [iserrorEmail, setiserrorEmail] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");

  const [formData, setFormData] = useState({
    Email: "",
    Role: "",
    Company: localStorage.getItem("company"),
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsloading(true);
    const token = await getToken();

    // console.log("Form Submitted:", formData);
    // Add further processing (e.g., API call)
    // var SelectedList = ["effem.com"];
    // var splitArray = formData.Email.split("@");

    const data = {
      email: formData.Email,
      userGroupId: parseInt(formData.Role),
      company: formData.Company,
    };
    const url = `${process.env.REACT_APP_SERVER_URL}/api/user/registerUserV2`;
    const header = {
      headers: {
        "oidc-token": token,
      },
    };

    if (
      formData.Company !== "" &&
      formData.Company !== null &&
      formData.Company !== undefined
    ) {
      axios
        .post(url, data, header)

        .then(function (response) {
          if (response.status === 201) {
            // console.log(response);
            setIsloading(false);
            setsuccess(true);
            handleReset();
            setTimeout(() => {
              setsuccess(false);
            }, 5000);
          }
        })
        .catch(function (error) {
          // console.log(error);
          if (error.status === 409) {
            setIsloading(false);
            seterrorMessage("User Already Exists");
            seterror(true);
            handleReset();
            setTimeout(() => {
              seterror(false);
              seterrorMessage("");
            }, 5000);
          }
          setIsloading(false);
          seterror(true);
          setTimeout(() => {
            seterror(false);
          }, 5000);
        });
    } else {
      localStorage.clear();
      window.location.href = "/";
    }
  };

  // Handle form reset
  const handleReset = () => {
    setFormData({
      Email: "",
      Role: "",
      Company: localStorage.getItem("company"),
    });
  };

  // push

  return (
    <div className="userRegistration">
      <div id="form-userRegistration">
        <form onSubmit={handleSubmit}>
          <div className="form-component-container">
            <div className="input-box">
              <label className="input-label">
                Email <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="input-field"
                id="Email"
                name="Email"
                placeholder="Email"
                required
                type="email"
                value={formData.Email}
                onChange={handleChange}
              />
            </div>

            <div className="input-box">
              <label className="input-label">
                Role <span style={{ color: "red" }}>*</span>
              </label>
              <select
                className="input-field"
                id="Role"
                name="Role"
                required
                value={formData.Role}
                onChange={handleChange}
              >
                <option value="">Select Role</option>
                <option value={104}>CB Admin (Lead auditor)</option>
                <option value={111}>CB Admin (Tech reviewer)</option>
                <option value={102}>Lead Auditor</option>
                <option value={112}>Tech Reviewer</option>
              </select>
            </div>
          </div>
          <div className="button-container">
            <button type="button" className="reset_btn" onClick={handleReset}>
              Reset
            </button>
            {/* <button type="submit" className="submit_btn">Submit</button> */}

            <Button disabled={isLoading} className="submit_btn" type="submit">
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span style={{ paddingLeft: "10px" }}>Registering..</span>
                </>
              ) : (
                "Register"
              )}
            </Button>
          </div>
        </form>

        {iserrorEmail && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "0px" }}
              variant="danger"
            >
              <p className="mb-0">Please use only '@effem.com'</p>
            </Alert>
          </div>
        )}

        {iserror && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "0px" }}
              variant="danger"
            >
              <p className="mb-0">
                {errorMessage ??
                  "Something went wrong, Please try after sometime"}
              </p>
            </Alert>
          </div>
        )}

        {issuccess && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "10px" }}
              variant="success"
            >
              <p className="mb-0">User Successfully Registered</p>
            </Alert>
          </div>
        )}
      </div>
    </div>
  );
};

export default CBUserReg;
